import React, {
    createContext, useState, useEffect, useMemo, 
   } from 'react';
   import PropTypes from 'prop-types';
   
   export const RestaurantContext = createContext();
   
   const RestaurantContextProvider = ({ children }) => {
    const [LocationRefesh, setLocationRefesh] = useState(false);
const [restaurantInfo, setRestaurantInfo] = useState({
  restaurantname: '',
  uin: '',
  addressline1: '',
  addressline2: '',
  area: '',
  city: '',
  state: '',
  country: '',
  pincode: '',
  latitude: '',
  longitude: '',
  maplink: '',
  description: '',
  logo: null,
  logo_name: '',
  settingCap: '',
  cuisines: '', 
  taxId: '',
  tStartTime: '', 
  tEndTime: '', 
  cappingCap: '',
  markup: '', 
  mealOffered: {
    breakfast: '',
    lunch: '',
    dinner: '',
    snacks: '',
  },
  mealFormat: {
    git: '',
    fit: '', 
    delivery: '',
  },
});



  // Memoize the context value to avoid unnecessary re-renders
  const value = useMemo(() => ({
    restaurantInfo,
    setRestaurantInfo,
    LocationRefesh, 
    setLocationRefesh,
  }), [
     restaurantInfo, 
     LocationRefesh]);

   
     return (
       <RestaurantContext.Provider value={value}>
         {children}
       </RestaurantContext.Provider>
     );
   };
   
   RestaurantContextProvider.propTypes = {
     children: PropTypes.node.isRequired,
   };
   
   export default RestaurantContextProvider;
